interface MealRecordListParamsInput {
  date: string | null;
  pageNo: number;
  pageSize: number;
  storeId: string | number | null;
  dishName: string | number | null;
  aiStatus: string | number | null;
  includeBlurry: boolean;
}

export const buildMealRecordListParams = ({
  date,
  pageNo,
  pageSize,
  storeId,
  dishName,
  aiStatus,
  includeBlurry,
}: MealRecordListParamsInput) => {
  const params: any = {
    date,
    pageNo,
    pageSize,
    storeId,
    dishName,
    aiStatus,
    onlyFood: true,
  };

  if (!includeBlurry) {
    params.fuzzyScore = 20;
  }

  return params;
};
